import { get, writable } from 'svelte/store';

const CIRCLE_KEY = 'shelly_dev_nav_indicator_circle';
const WIDE_KEY = 'shelly_dev_nav_dock_wide';

const readBool = (key: string, defaultValue: boolean): boolean => {
	try {
		const stored = localStorage.getItem(key);
		if (stored === null) return defaultValue;
		return stored === 'true';
	} catch {
		return defaultValue;
	}
};

const persist = (key: string, value: boolean) => {
	try {
		localStorage.setItem(key, String(value));
	} catch {
		// localStorage may be unavailable
	}
};

/** Circular active-item indicator on the floating dock (vs default capsule). */
export const navIndicatorCircleEnabled = writable<boolean>(readBool(CIRCLE_KEY, false));

navIndicatorCircleEnabled.subscribe((value) => persist(CIRCLE_KEY, value));

export const isNavIndicatorCircleEnabled = (): boolean => get(navIndicatorCircleEnabled);

export const setNavIndicatorCircleEnabled = (enabled: boolean) => {
	navIndicatorCircleEnabled.set(enabled);
};

/** Wider floating dock capsule (`PillShapedDock` `wide`). */
export const navDockWideEnabled = writable<boolean>(readBool(WIDE_KEY, false));

navDockWideEnabled.subscribe((value) => persist(WIDE_KEY, value));

export const isNavDockWideEnabled = (): boolean => get(navDockWideEnabled);

export const setNavDockWideEnabled = (enabled: boolean) => {
	navDockWideEnabled.set(enabled);
};
